import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { addLike, saved } from '../../features/details/detailsSlice';

const DetailsContainer = () => {
    const { loading, isError, errorMassage, details } = useSelector(state => state.details)
    const dispatch = useDispatch();

    const { title, image, tags, likes, isSaved, createdAt, id } = details;
    const handleAddLike = () => {
        dispatch(addLike(details))
    }
    const handleSave = () => {
        dispatch(saved(details))
    }

    return (
        <main className="post">
            <img src={image} alt="githum" className="w-full rounded-md" id="lws-megaThumb" />
            <div>
                <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
                    {title}
                </h1>
                <div className="tags" id="lws-singleTags">
                    {
                        tags?.map(single => <span key={single}>#{single}, </span>)
                    }
                </div>
                <div className="btn-group">
                    {/* <!-- handle like on button click --> */}
                    <button onClick={handleAddLike} className="like-btn" id="lws-singleLinks">
                        <i className="fa-regular fa-thumbs-up"></i> {likes}
                    </button>
                    {/* <!-- handle save on button click --> */}
                    {/* <!-- use ".active" class and "Saved" text  if a post is saved, other wise "Save" --> */}
                    <button onClick={handleSave} className={isSaved ? "active save-btn" : "save-btn"} id="lws-singleSavedBtn">
                        <i className="fa-regular fa-bookmark"></i> Saved
                    </button>
                </div>
                <div className="mt-6">
                    <p>
                        A MERN stack comprises a collection of four frameworks (MongoDB,
                        ExpressJs, ReactJs and NodeJs) used to develop full-stack
                        javascript solutions for rapid, scalable, and secure applications.
                        Each framework serves a different purpose in creating successful
                        web applications. It is an excellent choice for companies looking
                        to develop high-quality responsive applications quickly using just
                        one language.
                    </p>
                </div>
            </div>
        </main>
    );
};

export default DetailsContainer;